import FJHorizontalScroller from '../../../common/components/FJScroller/FJHorizontalScroller';
import styles from './FJFaceSwapTryThose.module.less';
import CatalogIcon from '../../../assets/svg/catalog-right.svg?react';
import FJConfig from '../../../config/FJConfig';
import classNames from 'classnames';
import { useState } from 'react';
import { useRef } from 'react';
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import FJFaceSwapData from '../../../config/dataConfig/FJFaceSwapData';
import FJHoverBoardGradation from '../../../common/components/FJHoverBoard/FJHoverBoardGradation';
import FJLoading from '../../../common/components/FJLoading/FJLoading';
import FJVersionConfig from '../../../config/FJVersionConfig';
import FJLocalStore from '../../../store/FJLocalStore.js';

const FJFaceSwapOriginTryThose = ({ onTryThose, type = 'origin', curLoadName }) => {
    const [isShowLeftCatalog, setIsShowLeftCatalog] = useState(false);
    const [isShowRightCatalog, setIsShowRightCatalog] = useState(false);

    const scrollRef = useRef(null);

    const _updateCatalogUI = () => {
        if (!scrollRef.current) return;
        const scrollDom = scrollRef.current?.getScroller();
        setIsShowLeftCatalog(scrollDom.scrollLeft !== 0);
        setIsShowRightCatalog(scrollDom.offsetWidth + scrollDom.scrollLeft !== scrollDom.scrollWidth);
    };

    const _switchPreview = isNext => {
        if (!scrollRef.current) return;
        const scrollDom = scrollRef.current?.getScroller();
        if (isNext) {
            // 滚动到下一屏的位置
            const nextScrollLeft = Math.min(scrollDom?.offsetWidth + scrollDom?.scrollLeft, scrollDom?.scrollWidth);
            scrollRef.current.scrollToLeft(nextScrollLeft, 'smooth');
        } else {
            // 滚动到上一屏的位置
            const prevScrollLeft = Math.max(scrollDom?.scrollLeft - scrollDom?.offsetWidth, 0);
            scrollRef.current.scrollToLeft(prevScrollLeft, 'smooth');
        }
        setTimeout(() => {
            _updateCatalogUI();
        }, 500);
    };

    useEffect(() => {
        _updateCatalogUI();
        window.addEventListener('resize', _updateCatalogUI);
        return () => {
            window.removeEventListener('resize', _updateCatalogUI);
        };
    }, []);

    const dataList = type === 'origin' ? FJFaceSwapData.THOSE_ORIGIN_IMAGES : FJFaceSwapData.THOSE_TARGET_IMAGES;

    const catalogPath = type === 'origin' ? FJConfig.thoseOriginImagesPath : FJConfig.thoseTargetImagesPath;

    return (
        <div className={styles.box}>
            <FJHorizontalScroller className={styles.scroller} ref={scrollRef} onMouseWheel={_updateCatalogUI}>
                {dataList.map((item, index) => (
                    <div className={styles.item_box} key={index}>
                        <FJHoverBoardGradation
                            isShowInBorder={true}
                            className={styles.try_those_images_list_item}
                            contentBoxClassName={styles.try_those_images_list_item_content}
                            onClick={() => onTryThose(item)}
                            borderRadius={6}
                        >
                            <img
                                src={catalogPath + item.name + '-min.png?v=' + FJVersionConfig.staticPathVersion}
                                alt=''
                            />
                            {curLoadName === item.name && (
                                <div className={styles.cur_load_box}>
                                    <FJLoading style={{ width: 16, height: 16 }} />
                                </div>
                            )}
                        </FJHoverBoardGradation>
                        {item.type === 'limit' && <div className={styles.limit}>{FJLocalStore._('exclusive')}</div>}
                    </div>
                ))}
            </FJHorizontalScroller>

            <div
                className={classNames(
                    styles.catalog_icon_box,
                    styles.catalog_left,
                    !isShowLeftCatalog ? styles.disable : '',
                )}
                onClick={() => {
                    _switchPreview(false);
                }}
            >
                <CatalogIcon />
            </div>
            <div
                className={classNames(
                    styles.catalog_icon_box,
                    styles.catalog_right,
                    !isShowRightCatalog ? styles.disable : '',
                )}
                onClick={() => {
                    _switchPreview(true);
                }}
            >
                <CatalogIcon />
            </div>
        </div>
    );
};

FJFaceSwapOriginTryThose.propTypes = {
    onTryThose: PropTypes.func,
    type: PropTypes.string,
    curLoadName: PropTypes.string,
};

export default FJFaceSwapOriginTryThose;
